export default () => {
  return 'https://ims-api.cs.usm.my/api/v1';
  if (window.location.host.indexOf('localhost') !== -1) {
    return 'https://ims-dev-api.cs.usm.my/api/v1';
  } else if (window.location.host.indexOf('ims-dev.cs.usm.my') !== -1) {
    return 'https://ims-dev-api.cs.usm.my/api/v1';
  } else if (window.location.host.indexOf('ims-new.cs.usm.my') !== -1) {
    return 'https://ims-api.cs.usm.my/api/v1';
  } else if (window.location.host.indexOf('ims-new.cs.usm.my') !== -1) {
  }
}